module.exports = __webpack_public_path__ + "static/tracer-tile-sq-isometric-02c8b14ee443d3130b22a016daf55b29.png";